import RoutesEnum from '../enums/routes';

export const RoutesGrouped = {
  CONSTELLATION_DINNERS_BASE: `${RoutesEnum.APPS}/${RoutesEnum.CONSTELLATION_DINNERS}`,
} as const;

export type GroupedRoutesType = typeof RoutesGrouped;
